import {Field} from "./Field";
import EvoText from "../../components/form/fields/EvoText";
import {Mask} from "./Features/mask/Mask";
import {PlaceholderMixin, ClassPlaceholderMixin} from "./Mixins/PlaceholderMixin";
import {mix} from "mixwith/mixwith"

/**
 * @extends Field
 * @extends ClassPlaceholderMixin
 */
export class Text extends mix(Field).with(PlaceholderMixin) {
    constructor() {
        super();
        this._component = EvoText;
        this._mask = null;
        this._type= 'text';
    }

    mask(mask) {
        this._mask = mask;
        return this;
    }
    type(value) {
        this._type = value;
        return this;
    }

}
